<template>
  <button class="back-link" @click="goBack(); scrollToTop();">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.97058 20">
      <g id="a" />
      <g id="b">
        <g id="c">
          <polygon
            class="d"
            points="16.97058 8.48529 8.48529 0 0 8.48529 5.24298 8.48529 5.24298 20 11.24298 20 11.24298 8.48529 16.97058 8.48529"
          />
        </g>
      </g>
    </svg>
    Back
  </button>
</template>
<script>
export default {
  methods: {
    goBack() {
      return this.$router.go(-1);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';
@import '@/styles/backBtn.scss';
@import '@/styles/media.scss';

</style>
